import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Button,
  Paper,
  Typography,
  Stack,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Tooltip,
  MenuItem,
  Autocomplete,
  CircularProgress,
  Chip,
  Checkbox,
  FormControlLabel,
  Divider,
  alpha,
  useTheme,
} from "@mui/material";
import {
  Add,
  Delete,
  Edit,
  CheckCircle,
  Save,
  Close,
  Terrain,
  Construction,
} from "@mui/icons-material";
import axios from "axios";
import api from "../../api";
import DataTableFrame from "../../components/common/DataTableFrame";

// YENİ BİLEŞENİ İMPORT ET
import CombinedLabUploadWrapper from "../../components/admin/CombinedLabUploadButton";
import CombinedTemplateExportWrapper from "../../components/admin/CombinedTemplateExportWrapper";
import LabExportExcelButton from "../../components/admin/LabExportExcelButton";
import JobMorphologyExportButton from "../../components/admin/JobMorphologyExportButton";
import JobTemplateExportButton from "../../components/admin/JobTemplateExportButton";
import JobTemplateExportButtonNew from "../../components/admin/JobTemplateExportButtonNew";
import JobTSondaExportButton from "../../components/admin/JobTSondaExportButton";
import PageShell, { PanelCard } from "../../components/common/PageShell";

const REGIONS = [
  "Marmara",
  "Ege",
  "Akdeniz",
  "İç Anadolu",
  "Karadeniz",
  "Doğu Anadolu",
  "Güneydoğu Anadolu",
];

export default function AdminJobs() {
  const theme = useTheme();
  const [jobs, setJobs] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);

  const [newJob, setNewJob] = useState({
    job_name: "",
    region: "",
    province: null,
    profile_active: true,
    sonda_active: true,
  });

  const [provinces, setProvinces] = useState([]);
  const [loading, setLoading] = useState({
    provinces: false,
  });

  useEffect(() => {
    fetchJobs();

    setLoading((prev) => ({ ...prev, provinces: true }));
    axios
      .get("https://api.turkiyeapi.dev/v1/provinces")
      .then((res) => {
        const sorted = res.data.data.sort((a, b) =>
          a.name.localeCompare(b.name),
        );
        setProvinces(sorted);
      })
      .catch((err) => console.error("İller hatası:", err))
      .finally(() => setLoading((prev) => ({ ...prev, provinces: false })));
  }, []);

  const fetchJobs = async () => {
    try {
      const res = await api.get("/admin/jobs");
      if (res.data.success) setJobs(res.data.jobs);
    } catch (error) {
      console.error("Çalışmalar yüklenemedi", error);
    }
  };

  const handleProvinceChange = (event, selectedProvince) => {
    setNewJob({
      ...newJob,
      province: selectedProvince,
    });
  };

  const handleSubmit = async () => {
    if (!newJob.job_name || !newJob.region || !newJob.province) {
      return alert("Çalışma adı, Bölge ve İl zorunludur!");
    }

    const payload = {
      job_name: newJob.job_name,
      region: newJob.region,
      province: newJob.province.name ? newJob.province.name : newJob.province,
      profile_active: newJob.profile_active,
      sonda_active: newJob.sonda_active,
      adminId: 1,
    };

    try {
      if (isEditing) {
        await api.put(`/admin/jobs/${editId}`, payload);
        alert("✅ Çalışma başarıyla güncellendi.");
      } else {
        await api.post("/admin/create-job", payload);
        alert("✅ Yeni çalışma eklendi.");
      }
      resetForm();
      fetchJobs();
    } catch (err) {
      console.error(err);
      alert(
        "❌ İşlem başarısız: " +
          (err.response?.data?.message || "Sunucu hatası"),
      );
    }
  };

  const handleEditClick = async (job) => {
    setIsEditing(true);
    setEditId(job.id);
    const foundProvince = provinces.find((p) => p.name === job.province);
    setNewJob({
      job_name: job.job_name,
      region: job.region,
      province: foundProvince || { name: job.province },
      profile_active: Boolean(job.profile_active),
      sonda_active: Boolean(job.sonda_active),
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const resetForm = () => {
    setIsEditing(false);
    setEditId(null);
    setNewJob({
      job_name: "",
      region: "",
      province: null,
      profile_active: true,
      sonda_active: true,
    });
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Silmek istediğinize emin misiniz?")) return;
    await api.delete(`/admin/jobs/${id}`);
    fetchJobs();
  };

  return (
    <PageShell title="Çalışma ve Süreç Yönetimi" icon={<Construction />}>

      <PanelCard
        accent={isEditing ? "#ed6c02" : undefined}
        sx={{ p: 3, bgcolor: isEditing ? "#fffbf2" : "#fff" }}
      >
        <Stack direction="row" justifyContent="space-between" mb={2}>
          <Typography
            variant="subtitle1"
            fontWeight="bold"
            color={isEditing ? "warning.dark" : "primary"}
          >
            {isEditing ? "Çalışma Ayarlarını Güncelle" : "Yeni Çalışma Oluştur"}
          </Typography>
          {isEditing && (
            <Button
              size="small"
              color="error"
              variant="outlined"
              startIcon={<Close />}
              onClick={resetForm}
            >
              VAZGEÇ
            </Button>
          )}
        </Stack>

        <Stack spacing={3}>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
            <TextField
              label="Çalışma Adı"
              size="small"
              value={newJob.job_name}
              onChange={(e) =>
                setNewJob({ ...newJob, job_name: e.target.value })
              }
              sx={{ flexGrow: 1, minWidth: "250px" }}
            />
            <TextField
              select
              label="Bölge"
              size="small"
              value={newJob.region}
              onChange={(e) => setNewJob({ ...newJob, region: e.target.value })}
              sx={{ minWidth: 180 }}
            >
              {REGIONS.map((r) => (
                <MenuItem key={r} value={r}>
                  {r}
                </MenuItem>
              ))}
            </TextField>
            <Autocomplete
              options={provinces}
              getOptionLabel={(option) => option.name || ""}
              isOptionEqualToValue={(option, value) =>
                option.name === value.name
              }
              value={newJob.province}
              onChange={handleProvinceChange}
              loading={loading.provinces}
              sx={{ minWidth: 200 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="İl"
                  size="small"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {loading.provinces && <CircularProgress size={20} />}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
          </Box>

          <Divider sx={{ borderStyle: "dashed" }}>SÜREÇ KONTROLÜ</Divider>

          <Stack
            direction="row"
            spacing={4}
            justifyContent="center"
            sx={{ bgcolor: "#f8f9fa", p: 1.5, borderRadius: 2 }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={newJob.profile_active}
                  onChange={(e) =>
                    setNewJob({ ...newJob, profile_active: e.target.checked })
                  }
                  color="primary"
                />
              }
              label={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Terrain
                    color={newJob.profile_active ? "primary" : "disabled"}
                  />
                  <Typography variant="body2" fontWeight="bold">
                    Profil Girişi Aktif
                  </Typography>
                </Box>
              }
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={newJob.sonda_active}
                  onChange={(e) =>
                    setNewJob({ ...newJob, sonda_active: e.target.checked })
                  }
                  color="secondary"
                />
              }
              label={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Construction
                    color={newJob.sonda_active ? "secondary" : "disabled"}
                  />
                  <Typography variant="body2" fontWeight="bold">
                    Sonda Girişi Aktif
                  </Typography>
                </Box>
              }
            />
          </Stack>

          <Button
            variant="contained"
            fullWidth
            size="large"
            color={isEditing ? "warning" : "primary"}
            startIcon={isEditing ? <Save /> : <Add />}
            onClick={handleSubmit}
            sx={{ fontWeight: "bold", borderRadius: 2, py: 1.2 }}
          >
            {isEditing ? "DEĞİŞİKLİKLERİ KAYDET" : "ÇALIŞMAYI SİSTEME EKLE"}
          </Button>
        </Stack>
      </PanelCard>

      {/* Ortak tablo cercevesi: tasma, yapisik baslik ve gorunum tek yerden yonetilir. */}
      <DataTableFrame minWidth={1500}>
        <TableHead>
          <TableRow>
            <TableCell>İş Bilgisi</TableCell>
            <TableCell>Bölge / İl</TableCell>
            <TableCell align="center">Profil Durumu</TableCell>
            <TableCell align="center">Sonda Durumu</TableCell>
            <TableCell align="right" sx={{ minWidth: 520 }}>
              İşlemler
            </TableCell>
          </TableRow>
        </TableHead>
          <TableBody>
            {jobs.map((job) => (
              <TableRow key={job.id} hover>
                <TableCell sx={{ whiteSpace: "nowrap" }}>
                  <Typography fontWeight="bold" variant="body2">
                    {job.job_name}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    ID: #{job.id}
                  </Typography>
                </TableCell>
                <TableCell sx={{ whiteSpace: "nowrap" }}>
                  <Stack direction="row" spacing={1}>
                    <Chip label={job.region} size="small" variant="outlined" />
                    <Typography variant="body2">{job.province}</Typography>
                  </Stack>
                </TableCell>
                <TableCell align="center">
                  {job.profile_active ? (
                    <Chip
                      icon={<CheckCircle />}
                      label="AÇIK"
                      color="success"
                      size="small"
                      variant="filled"
                    />
                  ) : (
                    <Chip label="KAPALI" size="small" variant="outlined" />
                  )}
                </TableCell>
                <TableCell align="center">
                  {job.sonda_active ? (
                    <Chip
                      icon={<CheckCircle />}
                      label="AÇIK"
                      color="secondary"
                      size="small"
                      variant="filled"
                    />
                  ) : (
                    <Chip label="KAPALI" size="small" variant="outlined" />
                  )}
                </TableCell>
                <TableCell align="right">
                  <Stack
                    direction="row"
                    spacing={2}
                    justifyContent="flex-end"
                    sx={{ flexWrap: "wrap", rowGap: 1 }}
                  >
                    {/* 1. TEK BUTONDAN YÜKLE (Profil ve Sonda İçinde Hazır) */}
                    <CombinedLabUploadWrapper
                      jobId={job.id}
                      onUploadSuccess={fetchJobs}
                    />

                    {/* 2. LAB EXCEL ÇIKTISI */}
                    <LabExportExcelButton
                      jobId={job.id}
                      jobName={job.job_name}
                    />

                    {/* 3. TEK BUTONDAN T-ŞABLON İNDİR (Profil ve Sonda İçinde Hazır) */}
                    <CombinedTemplateExportWrapper
                      jobId={job.id}
                      jobName={job.job_name}
                    />
                    <Divider orientation="vertical" flexItem sx={{ mx: 0.5 }} />

                    {/* 4. MORFOLOJİ */}
                    <JobMorphologyExportButton
                      jobId={job.id}
                      jobName={job.job_name}
                    />

                    {/* 5. T-PROFİL-1 */}
                    <JobTemplateExportButton
                      jobId={job.id}
                      jobName={job.job_name}
                    />
                    {/* 6. T-PROFİL-2 */}
                    <JobTemplateExportButtonNew
                      jobId={job.id}
                      jobName={job.job_name}
                    />
                    {/* 7. T-SONDA */}
                    <JobTSondaExportButton
                      jobId={job.id}
                      jobName={job.job_name}
                    />

                    <Divider orientation="vertical" flexItem sx={{ mx: 0.5 }} />

                    {/* DÜZENLE */}
                    <Tooltip title="Çalışmayı Düzenle">
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <IconButton
                          color="primary"
                          onClick={() => handleEditClick(job)}
                          sx={{
                            bgcolor: alpha(theme.palette.primary.main, 0.05),
                            mb: 0.5,
                          }}
                        >
                          <Edit fontSize="small" />
                        </IconButton>
                        <Typography
                          variant="caption"
                          sx={{
                            fontSize: "0.6rem",
                            color: "text.secondary",
                            fontWeight: "bold",
                          }}
                        >
                          DÜZENLE
                        </Typography>
                      </Box>
                    </Tooltip>

                    {/* SİL */}
                    <Tooltip title="Çalışmayı Sil">
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <IconButton
                          color="error"
                          onClick={() => handleDelete(job.id)}
                          sx={{
                            bgcolor: alpha(theme.palette.error.main, 0.05),
                            mb: 0.5,
                          }}
                        >
                          <Delete fontSize="small" />
                        </IconButton>
                        <Typography
                          variant="caption"
                          sx={{
                            fontSize: "0.6rem",
                            color: "text.secondary",
                            fontWeight: "bold",
                          }}
                        >
                          SİL
                        </Typography>
                      </Box>
                    </Tooltip>
                  </Stack>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
      </DataTableFrame>
    </PageShell>
  );
}
